import React from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import ScrollToTop from "./helper/ScrollToTop";
import { GlobalStyle } from "./components/common/styles/global.js";
import HomeOne from "./HomeOne";
import HomeTwo from "./HomeTwo";
import About from "./pages/about/About";
import CourseGrid from "./pages/courses/CourseGrid";
import CourseList from "./pages/courses/CourseList";
import CourseDetails from "./pages/courses/CourseDetails";
import Instructor from "./pages/instructor/Instructors";
import InstructorDetails from "./pages/instructor/InstructorDetails";
import Gallery from "./pages/gallery/Gallery";
import Events from "./pages/events/Events";
import EventDetails from "./pages/events/EventsDetails";
import Login from "./pages/account/Login";
import Register from "./pages/account/Register";
import Contact from "./pages/contact/Contact";
import Faq from "./pages/faq/Faq";
import PageNotFound from "./pages/404/PageNotFound";
import ComingSoon from "./pages/comingsoon/ComingSoon";
import BlogClassic from "./pages/blog/BlogClassic";
import BlogGrid from "./pages/blog/BlogGrid";
import BlogDetails from "./pages/blog/BlogDetails";
import Product from "./pages/shop/Products";
import ProductDetails from "./pages/shop/ProductDetails";
import Cart from "./pages/shop/Cart";
import Services from "./pages/services/Services.js";
import Franchise from "./pages/franchise/Franchise.js";
import Countries from "./pages/countries/Countries.js";
import IeltsCenter from "./pages/ieltsCenter/IeltsCenter.js";
import MeetTheTeam from "./pages/meetTheTeam/index.js";
import General from "./pages/general/General.js";
import OnlineSupport from "./pages/general/OnlineSupport.js";
import PrivacyPolicy from "./pages/general/PrivacyPolicy.js";
import HelpCenter from "./pages/general/HelpCenter.js";
import Apply from "./pages/apply/Apply";
const RoutedPages = () => {
  const location = useLocation();
  const base = process.env.PUBLIC_URL;

  return (
    <Routes location={location} key={location.pathname}>
      <Route path={`${base}/`} element={<HomeOne />} />
      <Route path={`${base}/home-two`} element={<HomeTwo />} />
      <Route path={`${base}/about`} element={<About />} />
      <Route path={`${base}/course-grid`} element={<CourseGrid />} />
      <Route path={`${base}/course-list`} element={<CourseList />} />
      <Route path={`${base}/course-details`} element={<CourseDetails />} />
      <Route path={`${base}/instructor`} element={<Instructor />} />
      <Route path={`${base}/instructor-details`} element={<InstructorDetails />} />
      <Route path={`${base}/gallery`} element={<Gallery />} />
      <Route path={`${base}/events`} element={<Events />} />
      <Route path={`${base}/event-details`} element={<EventDetails />} />
      <Route path={`${base}/login`} element={<Login />} />
      <Route path={`${base}/registration`} element={<Register />} />
      <Route path={`${base}/apply`} element={<Apply />} />
      <Route path={`${base}/contact`} element={<Contact />} />
      <Route path={`${base}/faq`} element={<Faq />} />
      <Route path={`${base}/404`} element={<PageNotFound />} />
      <Route path={`${base}/coming-soon`} element={<ComingSoon />} />
      <Route path={`${base}/blog-classic`} element={<BlogClassic />} />
      <Route path={`${base}/blog-grid`} element={<BlogGrid />} />
      <Route path={`${base}/blog-details`} element={<BlogDetails />} />
      <Route path={`${base}/products`} element={<Product />} />
      <Route path={`${base}/product-details`} element={<ProductDetails />} />
      <Route path={`${base}/cart`} element={<Cart />} />
      <Route path={`${base}/services`} element={<Services />} />
      <Route path={`${base}/franchise`} element={<Franchise />} />
      <Route path={`${base}/countries`} element={<Countries />} />
      <Route path={`${base}/ielts`} element={<IeltsCenter />} />
      <Route path={`${base}/meet-the-team`} element={<MeetTheTeam />} />
      <Route path={`${base}/general`} element={<General />} />
      <Route path={`${base}/online-support`} element={<OnlineSupport />} />
      <Route path={`${base}/privacy-policy`} element={<PrivacyPolicy />} />
      <Route path={`${base}/help-center`} element={<HelpCenter />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <GlobalStyle />
      <ScrollToTop />
      <RoutedPages />    </BrowserRouter>
  );
}

export default App;
